import { Spinner } from './Spinner';
export { Spinner };
// @deprecated - use named export instead
export default Spinner;
//# sourceMappingURL=index.js.map